module.exports = "/images/checkoutObservations.svg";